<template>
  <div class="collections-placeholder__root">
    <div class="left">
      <div
        v-for="item in 4"
        :key="`placeholder-key-${item}`"
        class="left-item loading-skeleton"
      >
      </div>
    </div>
    <div class="right adaptive-img">
      <div class="link-absolute loading-skeleton"></div>
    </div>
  </div>
</template>

<script setup lang="ts">

</script>

<style scoped lang="scss">
.collections-placeholder__root {
	display: flex;
	gap: 40px;
	width: 100%;

	& .left {
		width: 116px;
		display: flex;
		flex-direction: column;
		gap: 10px;
	}

	& .left-item {
		width: 100%;
		height: 88px;
		border-radius: 8px;

		&:after {
			border-radius: 8px;
		}
	}

	& .right {
		display: flex;
		flex: 1;
		border-radius: 8px;
		height: auto;
		overflow: hidden;

		&:before {
			padding-top: 70.216%;
		}

		& .loading-skeleton {
			height: 100%;
			width: 100%;
		}
	}
}

@media (max-width: 1200px) {
	.collections-placeholder__root {
		gap: 10px;

		& .left {
			width: 82px;
		}

		& .left-item {
			height: 62px;
		}
	}

}

@media (max-width: 1024px) {
	.collections-placeholder__root {
		& .left {
			display: none;
		}

		& .right {
			border-radius: 0 0 16px 16px;
			min-height: 603px;
		}
	}
}

@media (max-width: 1024px) {
	.collections-placeholder__root {
		& .left {
			display: none;
		}

		& .right {
			border-radius: 0 0 16px 16px;
			min-height: 603px;
		}
	}
}

@media (max-width: 860px) {
	.collections-placeholder__root {
		& .right {
			min-height: initial;
			margin: 0 -20px;
		}
	}
}
</style>
